import {atom, DefaultValue, selector} from 'recoil';

const loadingState = atom({
  key: 'alerts_table_loading',
  default: true
})

const errorState = atom({
  key: 'alerts_table_error',
  default: false
})

const rowsState = atom({
  key: 'alerts_table_rows',
  default: []
})

const firstRowIndexState = atom({
  key: 'alerts_table_first_row_index',
  default: 0
})

const pageSizeState = atom({
  key: 'alerts_table_page_size',
  default: 100
})

const selectedAlarmState = atom({
  key: 'alerts_table_selected_alarm',
  default: {}
})

const forwardAlarmsState = atom({
  key: 'alerts_table_forward_alarms',
  default: []
})

const editAlarmNoteModalOpenState = atom({
  key: 'alerts_table_edit_alarm_notes_open',
  default: false
})

const editAlarmNoteModalNotesState = atom({
  key: 'alerts_table_edit_alarm_notes',
  default: ""
})

const forwardToSupportAlarmModalOpenState = atom({
  key: 'alerts_table_forward_to_support_open',
  default: false
})

const forwardToSupportAlarmModalMessageState = atom({
  key: 'alerts_table_forward_to_support_message',
  default: ""
})

const editAlarmPriorityModalOpenState = atom({
  key: 'alerts_table_edit_alarm_priority_open',
  default: false
})

const editAlarmPriorityModalPriorityState = atom({
  key: 'alerts_table_edit_alarm_priority',
  default: ""
})

const forceCloseAlarmsModalOpenState = atom({
  key: 'alerts_table_force_close_alarms_open',
  default: false
})

const forceCloseAlarmsModalIdsState = atom({
  key: 'alerts_table_force_close_alarms_ids',
  default: []
})

const viewCustomerDetailModalOpenState = atom({
  key: 'alerts_table_view_customer_detail_open',
  default: false
})

const viewCustomerDetailModalCustomerCodeState = atom({
  key: 'alerts_table_view_customer_detail_customer_code',
  default: ""
})

const viewCustomerDetailModalCustomerState = atom({
  key: 'alerts_table_view_customer_detail_customer',
  default: null
})

const reportToUserModalOpenState = atom({
  key: 'alerts_table_report_to_user_open',
  default: false
})

const postponeAlarmModalOpenState = atom({
  key: 'alerts_table_postpone_alarm_open',
  default: false
})

const filtersStorageKey = "freddosrl_guardian__alarms_filters"

const filtersState = atom({
  key: 'alerts_table_filters',
  default: JSON.parse(localStorage.getItem(filtersStorageKey)),
})

const alarmsFilterDefault = {
  "filter_severity_grave": {
    value: "Grave",
    enabled: true
  },
  "filter_severity_lieve": {
    value: "Lieve",
    enabled: true
  },
  "filter_severity_informativo": {
    value: "Informativo",
    enabled: true
  },
  "filter_h24_only": {
    enabled: false
  },
}

const filtersSelector = selector({
  key: 'alerts_table_filters_selector',
  get: ({get}) => {
    let filters = get(filtersState)
    if (filters == null) {
      filters = alarmsFilterDefault
    }
    return filters
  },
  set: ({set}, value) => {
    if (value instanceof DefaultValue) {
      set(filtersState, value)
      return;
    }
    set(filtersState, value)
    localStorage.setItem(filtersStorageKey, JSON.stringify(value))
  }
})

export {
  loadingState,
  errorState,
  rowsState,
  firstRowIndexState,
  pageSizeState,
  selectedAlarmState,
  editAlarmNoteModalOpenState,
  editAlarmNoteModalNotesState,
  editAlarmPriorityModalOpenState,
  editAlarmPriorityModalPriorityState,
  forceCloseAlarmsModalOpenState,
  forceCloseAlarmsModalIdsState,
  viewCustomerDetailModalOpenState,
  viewCustomerDetailModalCustomerCodeState,
  viewCustomerDetailModalCustomerState,
  forwardToSupportAlarmModalOpenState,
  forwardToSupportAlarmModalMessageState,
  reportToUserModalOpenState,
  postponeAlarmModalOpenState,
  filtersSelector,
  forwardAlarmsState,
}